<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('user_training_flights')"
    :max-width="400"
    color="primary"
    activator-button
    custom-class="mr-2"
    @open="showUserTrainingFlights"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-list two-line style="height: 550px; overflow-y: scroll">
        <v-list-item-group
          v-model="selected"
          active-class="blue--text"
        >
          <template v-for="(flight, index) in flights">
            <v-list-item :key="flight.id">
              <v-list-item-content>
                <v-list-item-title> {{ flight.plane.reg_num }} - {{ flight.plane.model }} </v-list-item-title>
                <v-list-item-title> {{ flight.pic.name }} </v-list-item-title>
                <v-list-item-subtitle> {{ flight.date | dateFormat }} -> {{ flight.takeoff_time | timeFormat }} - {{ flight.landing_time | timeFormat }} </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  color="primary"
                  small
                  @click="clickFlightSelect(flight)"
                >
                  {{ $t('select') }}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index !== 0 && flights[index].date != flights[index-1].date"
              :key="index"
            />
          </template>
        </v-list-item-group>
      </v-list>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'UserTrainingFlightSelector',
    props: {
      userTrainingTask: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialogInfo: false,
        flights: [],
        selected: [],
        current_date: null,
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    methods: {
      userTrainingFlights: call('userTrainingTask/userTrainingFlights'),
      userTrainingAddFlight: call('userTrainingTask/userTrainingAddFlight'),
      async showUserTrainingFlights () {
        console.log('showUserStat')
        this.loading = true
        await this.userTrainingFlights({ user_id: this.userTrainingTask.user_id, user_training_task_id: this.userTrainingTask.id }).then(response => {
          this.flights = response
          this.dialogInfo = true
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      clickFlightSelect (flight) {
        this.userTrainingAddFlight({ id: this.userTrainingTask.id, flight_id: flight.id }).then(response => {
          this.$set(flight, 'pivot', { comment: '', success: 0 })
          this.userTrainingTask.flights.push(flight)
        })
        this.closeDialog()
      },
      dividerOn (flight) {
        if (this.current_date !== flight.date) {
          this.current_date = flight.date
          return true
        } else {
          return false
        }
        // return true
      },
      closeDialog () {
        this.flights = []
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
